import { useCallback, useMemo, useState } from "react";
import { BsCopy } from "react-icons/bs";

import { PlanDiscountsInput } from "~/components/PlanDiscountsInput";
import { insertToast } from "~/modules/toasts/services";
import { planCheckoutRoute } from "~/routes/routes";

type Props = {
	planId: string;
};

export const PlanLink: React.FC<Props> = ({ planId }) => {
	const [discount, setDiscount] = useState<string>("");

	const linkUrl = useMemo(() => {
		const baseUrl = new URL(`${window.location.origin}${planCheckoutRoute}`);
		const searchParams = new URLSearchParams();

		searchParams.append("plan", planId);
		discount && searchParams.append("coupon", discount);
		baseUrl.search = searchParams.toString();
		return baseUrl.toString();
	}, [planId, discount]);

	const handleChange = useCallback((code: string) => {
		setDiscount(code);
	}, []);

	const handleCopyLink = useCallback(() => {
		navigator.clipboard.writeText(linkUrl);
		insertToast({
			title: "Link copiado!",
			duration: 3,
		});
	}, [linkUrl]);

	return (
		<div className="flex flex-col gap-4">
			<PlanDiscountsInput
				planId={planId}
				onChange={handleChange}
				label="Selecione um cupom de desconto, caso queira"
			/>

			<div
				className="flex border-slate-300/50 bg-slate-50 border-2 rounded-lg
        overflow-hidden"
			>
				<div className="flex-1 p-2">
					<p className="line-clamp-1">{linkUrl}</p>
				</div>

				<button
					className="shrink-0 text-slate-500 bg-slate-200 p-2 pl-3"
					onClick={handleCopyLink}
				>
					<BsCopy size={22} />
				</button>
			</div>
		</div>
	);
};
